import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronUp, FiChevronDown, FiSearch } = FiIcons;

const SortableTableHeader = ({ 
  columns, 
  sortConfig, 
  onSort, 
  searchFilters, 
  onSearchChange 
}) => {
  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return null;
    return sortConfig.direction === 'asc' ? FiChevronUp : FiChevronDown;
  };

  return (
    <thead className="bg-gray-50">
      <tr>
        {columns.map((column) => (
          <th key={column.key} className="px-6 py-3 text-left">
            <div className="space-y-2">
              {/* Header with sorting */}
              <div 
                className={`flex items-center space-x-1 ${
                  column.sortable ? 'cursor-pointer hover:text-blue-600' : ''
                }`}
                onClick={() => column.sortable && onSort(column.key)}
              >
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {column.label}
                </span>
                {column.sortable && (
                  <SafeIcon 
                    icon={getSortIcon(column.key) || FiChevronUp} 
                    className={`h-3 w-3 ${
                      sortConfig.key === column.key ? 'text-blue-600' : 'text-gray-400'
                    }`} 
                  />
                )}
              </div>
              
              {/* Search input */}
              {column.searchable && (
                <div className="relative">
                  <SafeIcon 
                    icon={FiSearch} 
                    className="absolute left-2 top-1/2 transform -translate-y-1/2 h-3 w-3 text-gray-400" 
                  />
                  <input
                    type="text"
                    placeholder={`ค้นหา${column.label}...`}
                    value={searchFilters[column.key] || ''}
                    onChange={(e) => onSearchChange(column.key, e.target.value)}
                    className="w-full pl-7 pr-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              )}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default SortableTableHeader;